import './Process.css';

const steps = [
  {
    num: '01',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
    title: 'Free Consultation',
    desc: 'Every engagement starts with a free consultation where we listen to your requirements, understand your goals, and assess the scope of work. Via WhatsApp, email, or video call — whichever is most convenient.',
  },
  {
    num: '02',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
    title: 'Proposal & Agreement',
    desc: 'We prepare a detailed proposal outlining scope, timeline, deliverables, and pricing. Once approved, we sign a service agreement and NDA. A 50% advance payment is required to begin work.',
  },
  {
    num: '03',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
    title: 'Discovery & Planning',
    desc: 'For web projects, we study competitors, define target audience, and create a sitemap. For AI projects, we analyze data and define model architecture. For research, we review existing work and plan the approach.',
  },
  {
    num: '04',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>,
    title: 'Design & Development',
    desc: 'For websites, we start with Figma wireframes for your approval, then move to development. For AI, we prepare datasets and train models. For research, we write and refine content. Regular progress updates throughout.',
  },
  {
    num: '05',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>,
    title: 'Review & Revisions',
    desc: 'Once initial work is complete, we share it for review. All packages include free revision rounds — typically 3 rounds for web and AI projects, and unlimited minor revisions for research work.',
  },
  {
    num: '06',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
    title: 'Delivery & Support',
    desc: 'After final approval, we deliver the completed work and collect the remaining 50% payment. Deployment, documentation, and post-delivery support included for 7–14 days.',
  },
];

export default function Process() {
  return (
    <section className="process-section" id="process">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <span className="section-tag">Our Process</span>
          <h2 className="process-title">How We Work — <span>Agile, Transparent & Effective</span></h2>
          <p className="process-sub">We follow an Agile methodology — iterative, collaborative, and client-focused. Here is exactly what working with LathiNyx DevLabs™ looks like from first contact to final delivery.</p>
        </div>
        <div className="process-grid">
          {steps.map((step, i) => (
            <div key={step.num} className="process-card">
              <div className="process-card-top">
                <div className="process-icon">{step.icon}</div>
                <div className="process-num">{step.num}</div>
              </div>
              <h3 className="process-step-title">{step.title}</h3>
              <p className="process-step-desc">{step.desc}</p>
              {i < steps.length - 1 && <div className="process-connector" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
